export var Security;
(function (Security) {
    Security["API_KEY_HEADER"] = "x-domainpage-api-key";
})(Security || (Security = {}));
